<h2
  appDialogTitle
  class="d-flex align-items-center justify-content-between"
  [ngStyle]="data.titleStyle"
>
  {{ data.title }}
  <app-button [appDialogClose]="null" size="circle-small">
    <app-icon>close</app-icon>
  </app-button>
</h2>
<div appDialogContent>
  <ng-container *ngIf="data?.templateContent; else noTemplate">
    <ng-container *ngTemplateOutlet="data?.templateContent"></ng-container>
  </ng-container>
  <ng-template #noTemplate>
    <div class="small-form-field">
      <div [ngStyle]="data.contentStyle">{{ data.content }}</div>
      <app-form-field
        appearance="outline"
        *ngFor="let input of data.inputs; let i = index"
        class="w-100"
        [ngClass]="{
          'pt-1 mt-3': data.content && i === 0,
          'mt-2': i === 1,
        }"
      >
        <app-label>{{ input.label }}</app-label>
        <app-input
          [type]="input.type"
          [required]="input.required"
          [(ngModel)]="inputValues[i]"
        ></app-input>
      </app-form-field>
    </div>
  </ng-template>
</div>
<div appDialogActions align="end">
  <app-button
    [variant]="data.color === 'accent' ? 'destructive' : 'ghost-primary'"
    *ngIf="!!data.noButton"
    (click)="onNoClicked()"
    cdkFocusInitial
  >
    {{ data.noButton }}
  </app-button>
  <app-button
    [variant]="data.color === 'accent' ? 'destructive' : 'ghost-primary'"
    *ngIf="!!data.yesButton"
    [disabled]="data.inputs?.length && missingRequired"
    (click)="onOkClick()"
  >
    {{ data.yesButton }}
  </app-button>
</div>
